export enum OfferTabs {
  AVAILABLE = 'AVAILABLE',
  PENDING = 'PENDING',
  REFUSED_BY_HUBLER = 'REFUSED_BY_HUBLER',
  REFUSED_BY_HUBLER_NETWORK = 'REFUSED_BY_HUBLER_NETWORK',
}
